import React, { PropsWithChildren } from "react";
import LoadingOverlay from 'react-loading-overlay-ts';
import LoadingComponent from "./LoadingComponent";

interface ILoadingComponentOverlayProps {
  active: boolean;
  fullPage?: boolean;
}

const LoadingComponentOverlay = (props:PropsWithChildren<ILoadingComponentOverlayProps>) => {
  return (
    <LoadingOverlay
      active={props.active}
      spinner={ <LoadingComponent/>}
      styles={{
        overlay: (base) => ({
          ...base,
          background: 'rgba(97, 97, 97, .05)'
        })
      }}
      >
        {props.children}
         </LoadingOverlay>
   
  );
};

export default LoadingComponentOverlay;